<template>
    <div id="app">
        <router-view name="header"></router-view>
        <main class="h-100">
            <fade-transition origin="center" mode="out-in" :duration="250">
                <router-view/>
            </fade-transition>
        </main>
        <router-view name="footer"></router-view>
    </div>
</template>
<script>
import { FadeTransition } from "vue2-transitions";

export default {
  components: {
    FadeTransition
  }
};
</script>

<style>
body,
html {
  height: 100%;
}

.bg {
  background-color: var(--light);
  /* The image used */
  background-image: url('/img/ff/InsideBG.png');
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.hide {
  visibility: hidden;
}
.cropped {
  object-fit: cover; /* Do not scale the image */
  object-position: left; /* Center the image within the element */
  height: 500px;
  width: 600px;
}
.copy p {
  font-weight: bold;
}

</style>
